import {DefaultTheme} from 'styled-components';
import {black, white} from '../colors';

import {Theme as NewsTheme} from './news';

export const ThemeAlternative: DefaultTheme = {
    ...NewsTheme,
    color: {
        foreground: white,
        background: black
    },
    font: {
        ...NewsTheme.font,
        weight: {
            normal: 400
        }
    }
};
